export const getHccCode = (code: unknown): number | undefined => {
  if (!code || typeof code !== 'object' || !('hcc_code' in code)) return undefined;
  const value = (code as { hcc_code?: number | null }).hcc_code;
  return typeof value === 'number' ? value : undefined;
};
